import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { BuildingIcon, CreditCardIcon, LockIcon, WalletIcon } from 'lucide-react';
import { useCart } from '../contexts/CartContext';
import { formatPrice } from '../utils/format';
import { COLORS } from '../data/products';
const STEPS = [{
  id: 1,
  label: 'Información de contacto'
}, {
  id: 2,
  label: 'Dirección de envío'
}, {
  id: 3,
  label: 'Método de pago'
}];
const PAYMENTS = [{
  id: 'card',
  label: 'Tarjeta de crédito/débito',
  hint: 'Visa, Mastercard, OCA, Cabal',
  icon: CreditCardIcon
}, {
  id: 'mp',
  label: 'MercadoPago',
  hint: 'Pagá con tu saldo o cuotas sin interés',
  icon: WalletIcon
}, {
  id: 'transfer',
  label: 'Transferencia bancaria',
  hint: 'BROU, Itaú, Santander — 5 % off',
  icon: BuildingIcon
}];
const DEPARTMENTS = ['Montevideo', 'Canelones', 'Maldonado', 'Colonia', 'Salto', 'Paysandú', 'Rivera', 'Tacuarembó'];
const fieldClass = 'w-full border border-white/10 bg-ink-800 px-4 py-3.5 text-sm text-white placeholder:text-white/30 focus:border-pink-500 focus:outline-none';
const labelClass = 'block text-[10px] font-bold uppercase tracking-[0.2em] text-white/45';
export function Checkout() {
  const {
    lines,
    lineProduct,
    subtotal,
    shipping,
    discount,
    total,
    couponCode
  } = useCart();
  const navigate = useNavigate();
  const [payment, setPayment] = useState('card');
  return <div className="w-full bg-black" data-id="element-911" data-mp="3gg9fsb7cbf80">
      <div className="mx-auto w-full max-w-7xl px-5 py-12 lg:px-8 lg:py-16" data-id="element-912" data-mp="3lcq9dkxb6lsh">
        <h1 className="font-display text-5xl uppercase leading-none text-white sm:text-6xl" data-id="element-913" data-mp="3qccknotktryn">
          Checkout
        </h1>

        {/* STEP INDICATOR */}
        <ol className="mt-9 flex flex-col gap-4 border-y border-white/10 py-6 sm:flex-row sm:items-center sm:gap-8" data-id="element-914" data-mp="3ufhj9gajd9i0">
          {STEPS.map(step => <li key={step.id} className="flex items-center gap-3" data-id="element-915" data-mp="19nfjch8s2x81">
              <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-pink-500 font-display text-sm text-white" data-id="element-916" data-mp="19ps4f39u1npb">
                {step.id}
              </span>
              <span className="text-[11px] font-bold uppercase tracking-[0.16em] text-white" data-id="element-917" data-mp="31oz08i6ttbb1">
                {step.label}
              </span>
              {step.id !== 3 && <span className="hidden h-[1px] w-10 bg-white/15 sm:block" data-id="element-918" data-mp="3ar86gvv2aiim" />}
            </li>)}
        </ol>

        <form onSubmit={e => {
        e.preventDefault();
        navigate('/confirmacion');
      }} className="mt-10 grid gap-10 lg:grid-cols-[1fr_380px]" data-id="element-919" data-mp="2mxzstahq8st1">
          <div className="space-y-12" data-id="element-920" data-mp="2ws06i0r2r6dd">
            {/* STEP 1 */}
            <section aria-labelledby="step-1" data-id="element-921" data-mp="2rxvxlby90o9n">
              <h2 id="step-1" className="font-display text-3xl uppercase leading-none text-white" data-id="element-922" data-mp="249l2kpf8hita">
                <span className="text-pink-500" data-id="element-923" data-mp="1za00450uusbt">01</span> Información de contacto
              </h2>
              <div className="mt-6 grid gap-5 sm:grid-cols-2" data-id="element-924" data-mp="erxp5r0jfjez">
                <div data-id="element-925" data-mp="jjz6vsgh62ce">
                  <label className={labelClass} htmlFor="nombre" data-id="element-926" data-mp="jkh8z5ptjas8">
                    Nombre completo
                  </label>
                  <input id="nombre" required autoComplete="name" placeholder="Camila Rodríguez" className={`mt-2 ${fieldClass}`} data-id="element-927" data-mp="5tvppfwgcytt" />
                </div>
                <div data-id="element-928" data-mp="12ha1v0v2q9m1">
                  <label className={labelClass} htmlFor="email" data-id="element-929" data-mp="12hihv1mhtv1g">
                    Email
                  </label>
                  <input id="email" type="email" required autoComplete="email" placeholder="camila@mail.com" className={`mt-2 ${fieldClass}`} data-id="element-930" data-mp="okwn3zhxcmb9" />
                </div>
                <div className="sm:col-span-2" data-id="element-931" data-mp="3e5hurevouzi4">
                  <label className={labelClass} htmlFor="tel" data-id="element-932" data-mp="3tij3x3s0b9pt">
                    Teléfono
                  </label>
                  <input id="tel" type="tel" required autoComplete="tel" placeholder="+598 99 123 456" className={`mt-2 ${fieldClass}`} data-id="element-933" data-mp="3op7wp1ja8qxd" />
                </div>
              </div>
            </section>

            {/* STEP 2 */}
            <section aria-labelledby="step-2" data-id="element-934" data-mp="c8ufj9565tpf">
              <h2 id="step-2" className="font-display text-3xl uppercase leading-none text-white" data-id="element-935" data-mp="ca5orohdvtnx">
                <span className="text-pink-500" data-id="element-936" data-mp="2bpu5bj5e29o">02</span> Dirección de envío
              </h2>
              <div className="mt-6 grid gap-5 sm:grid-cols-2" data-id="element-937" data-mp="2s11jvrc7is80">
                <div className="sm:col-span-2" data-id="element-938" data-mp="2ryfe9x8vmmsf">
                  <label className={labelClass} htmlFor="calle" data-id="element-939" data-mp="2n15pmjtbaf5n">
                    Dirección
                  </label>
                  <input id="calle" required autoComplete="street-address" placeholder="Bvar. Artigas 1234, apto 502" className={`mt-2 ${fieldClass}`} data-id="element-940" data-mp="2cythykkrkj7x" />
                </div>
                <div data-id="element-941" data-mp="2rn6dxhjuq22f">
                  <label className={labelClass} htmlFor="depto" data-id="element-942" data-mp="2rnpm46jp9c39">
                    Departamento
                  </label>
                  <select id="depto" required defaultValue="Montevideo" className={`mt-2 ${fieldClass}`} data-id="element-943" data-mp="30n2vkz7tq0nz">
                    {DEPARTMENTS.map(d => <option key={d} value={d} data-id="element-944" data-mp="3ajxuvkbx853b">
                        {d}
                      </option>)}
                  </select>
                </div>
                <div data-id="element-945" data-mp="1g6g31l4hgm2h">
                  <label className={labelClass} htmlFor="ciudad" data-id="element-946" data-mp="1g80xzbupm70v">
                    Ciudad / Barrio
                  </label>
                  <input id="ciudad" required placeholder="Pocitos" className={`mt-2 ${fieldClass}`} data-id="element-947" data-mp="188mjx8rb6yz9" />
                </div>
                <div data-id="element-948" data-mp="1d5mrjo3t49sh">
                  <label className={labelClass} htmlFor="cp" data-id="element-949" data-mp="1d5d7si9cuyv8">
                    Código postal
                  </label>
                  <input id="cp" required autoComplete="postal-code" placeholder="11300" className={`mt-2 ${fieldClass}`} data-id="element-950" data-mp="1r433pukfusi0" />
                </div>
                <div data-id="element-951" data-mp="1vvkuxqwnteps">
                  <label className={labelClass} htmlFor="notas" data-id="element-952" data-mp="1vx5rfm2jb7qa">
                    Referencia (opcional)
                  </label>
                  <input id="notas" placeholder="Dejar en portería" className={`mt-2 ${fieldClass}`} data-id="element-953" data-mp="29w5hmy5p3uok" />
                </div>
              </div>
            </section>

            {/* STEP 3 */}
            <section aria-labelledby="step-3" data-id="element-954" data-mp="2tgmbs1rz882u">
              <h2 id="step-3" className="font-display text-3xl uppercase leading-none text-white" data-id="element-955" data-mp="2tfb8s46cv4cs">
                <span className="text-pink-500" data-id="element-956" data-mp="2kfy2tlhfwxwt">03</span> Método de pago
              </h2>
              <div className="mt-6 space-y-3" data-id="element-957" data-mp="25ruqluct0pzk">
                {PAYMENTS.map(({
                id,
                label,
                hint,
                icon: Icon
              }) => <label key={id} className={`flex cursor-pointer items-center gap-4 border p-4 transition-colors ${payment === id ? 'border-pink-500 bg-pink-500/5' : 'border-white/10 bg-ink-800 hover:border-white/30'}`} data-id="element-958" data-mp="2ajl7yka5se0h">
                    <input type="radio" name="payment" checked={payment === id} onChange={() => setPayment(id)} className="h-4 w-4 shrink-0 appearance-none rounded-full border border-white/25 checked:border-[5px] checked:border-pink-500 focus:outline-none" data-id="element-959" data-mp="1rslcd085s5y8" />
                    <Icon className={`h-5 w-5 shrink-0 ${payment === id ? 'text-pink-500' : 'text-white/40'}`} data-id="element-960" data-mp="1tb3gs71290kg" />
                    <span className="min-w-0" data-id="element-961" data-mp="1jk8tr0fzpwxy">
                      <span className="block text-sm font-semibold text-white" data-id="element-962" data-mp="1jjfxitenqpu2">
                        {label}
                      </span>
                      <span className="block text-xs text-white/40" data-id="element-963" data-mp="1akccvkzue2dg">{hint}</span>
                    </span>
                  </label>)}
              </div>

              {payment === 'card' && <div className="mt-6 grid gap-5 border border-white/10 bg-ink-800 p-5 sm:grid-cols-2" data-id="element-964" data-mp="10ld4m3izo8qz">
                  <div className="sm:col-span-2" data-id="element-965" data-mp="3ca1d4rmtlyab">
                    <label className={labelClass} htmlFor="card-num" data-id="element-966" data-mp="3cbchask6h81y">
                      Número de tarjeta
                    </label>
                    <input id="card-num" inputMode="numeric" placeholder="4242 4242 4242 4242" className={`mt-2 ${fieldClass} bg-ink-900`} data-id="element-967" data-mp="3m6wdzh6kgarr" />
                  </div>
                  <div className="sm:col-span-2" data-id="element-968" data-mp="2tgxl1ap93tht">
                    <label className={labelClass} htmlFor="card-name" data-id="element-969" data-mp="2yimvao4ng34u">
                      Titular de la tarjeta
                    </label>
                    <input id="card-name" placeholder="CAMILA RODRIGUEZ" className={`mt-2 ${fieldClass} bg-ink-900 uppercase`} data-id="element-970" data-mp="32hlv5ubix9pf" />
                  </div>
                  <div data-id="element-971" data-mp="2et2plmjuzb11">
                    <label className={labelClass} htmlFor="card-exp" data-id="element-972" data-mp="2esjf2qwjfox1">
                      Vencimiento
                    </label>
                    <input id="card-exp" placeholder="MM / AA" className={`mt-2 ${fieldClass} bg-ink-900`} data-id="element-973" data-mp="269zv35ommqdb" />
                  </div>
                  <div data-id="element-974" data-mp="2k76cavtpch0f">
                    <label className={labelClass} htmlFor="card-cvv" data-id="element-975" data-mp="2k7oiak6629lj">
                      CVV
                    </label>
                    <input id="card-cvv" inputMode="numeric" placeholder="123" className={`mt-2 ${fieldClass} bg-ink-900`} data-id="element-976" data-mp="1niqksu717xko" />
                  </div>
                </div>}
            </section>
          </div>

          {/* SUMMARY */}
          <aside className="lg:sticky lg:top-28 lg:self-start" data-id="element-977" data-mp="13tg9dsebjysd">
            <div className="border border-white/10 bg-ink-800 p-6" data-id="element-978" data-mp="13r3ph9p03eco">
              <h2 className="font-display text-2xl uppercase tracking-wide text-white" data-id="element-979" data-mp="18qygdd8s03xq">
                Tu pedido
              </h2>

              <ul className="mt-6 space-y-4" data-id="element-980" data-mp="116nst6nyj2mq">
                {lines.map(line => {
                const product = lineProduct(line);
                if (!product) return null;
                const color = COLORS.find(c => c.id === line.colorId);
                const unit = product.salePrice ?? product.price;
                return <li key={line.id} className="flex items-center gap-3" data-id="element-981" data-mp="iaxrllnuma9w">
                      <div className="relative h-14 w-14 shrink-0 overflow-hidden bg-black" data-id="element-982" data-mp="dinunlobg9y4">
                        <img src={product.images[0]} alt={product.name} className="h-full w-full object-cover" data-id="element-983" data-mp="8jtd0n234rfl" />
                        <span className="absolute right-0 top-0 bg-pink-500 px-1 text-[10px] font-bold text-white" data-id="element-984" data-mp="3vp27fhaumdux">
                          {line.quantity}
                        </span>
                      </div>
                      <div className="min-w-0 flex-1" data-id="element-985" data-mp="3h10vbw59id8q">
                        <p className="truncate text-sm font-semibold text-white" data-id="element-986" data-mp="3l3p3s2q2di56">
                          {product.name}
                        </p>
                        <p className="text-xs text-white/40" data-id="element-987" data-mp="3757gg642m7ns">{color?.name}</p>
                      </div>
                      <span className="text-sm text-white" data-id="element-988" data-mp="3c3irula0kq84">
                        {formatPrice(unit * line.quantity)}
                      </span>
                    </li>;
              })}
              </ul>

              <dl className="mt-6 space-y-3 border-t border-white/10 pt-6 text-sm" data-id="element-989" data-mp="8o3aeyzb3ecy">
                <div className="flex justify-between" data-id="element-990" data-mp="3q2i8b5ndhyt7">
                  <dt className="text-white/50" data-id="element-991" data-mp="3v135ew7bw2df">Subtotal</dt>
                  <dd className="text-white" data-id="element-992" data-mp="3uzictc4kqti7">{formatPrice(subtotal)}</dd>
                </div>
                <div className="flex items-center justify-between" data-id="element-993" data-mp="mk8emf3t28fp">
                  <dt className="text-white/50" data-id="element-994" data-mp="recmr1ot4mid">Envío</dt>
                  <dd data-id="element-995" data-mp="2c2ne9xq7kt7m">
                    {shipping === 0 ? <span className="bg-teal-500 px-2 py-1 text-[10px] font-bold uppercase tracking-[0.14em] text-black" data-id="element-996" data-mp="2c12mugz6xqdz">
                        Gratis
                      </span> : <span className="text-white" data-id="element-997" data-mp="2kxbmnwr2yr0n">{formatPrice(shipping)}</span>}
                  </dd>
                </div>
                {discount > 0 && <div className="flex justify-between" data-id="element-998" data-mp="1t6f6on9q4695">
                    <dt className="text-white/50" data-id="element-999" data-mp="1o69mfs5s9m13">Descuento {couponCode}</dt>
                    <dd className="text-pink-400" data-id="element-1000" data-mp="224r2r4tczw8z">- {formatPrice(discount)}</dd>
                  </div>}
              </dl>

              <div className="mt-6 flex items-end justify-between border-t border-white/10 pt-6" data-id="element-1001" data-mp="1x54oqt5pibz4">
                <span className="text-[11px] font-bold uppercase tracking-[0.2em] text-white/50" data-id="element-1002" data-mp="3div1eoaw68kd">
                  Total
                </span>
                <span className="font-display text-4xl leading-none text-white" data-id="element-1003" data-mp="7pvgg4c4clcf">
                  {formatPrice(total)}
                </span>
              </div>

              <button type="submit" className="mt-6 w-full bg-pink-500 py-4 text-xs font-bold uppercase tracking-[0.2em] text-white transition-colors hover:bg-pink-600" data-id="element-1004" data-mp="cpgmsztmbvz6">
                Confirmar pedido
              </button>
              <p className="mt-4 flex items-center justify-center gap-2 text-[11px] text-white/35" data-id="element-1005" data-mp="qnojd6mqsv9t">
                <LockIcon className="h-3.5 w-3.5" data-id="element-1006" data-mp="vmrdhw16ph30" /> Pago protegido con
                encriptación SSL
              </p>
              <Link to="/carrito" className="mt-4 block text-center text-[11px] uppercase tracking-[0.16em] text-white/50 hover:text-white" data-id="element-1007" data-mp="10f1a1uwt1fe9">
                Volver al carrito
              </Link>
            </div>
          </aside>
        </form>
      </div>
    </div>;
}